import { TFunction } from 'i18next';

const sizeToSpeedRatioLarge = (t: TFunction<'translation', undefined>) => [
  {
    value: 4000,
    label: `160 ${t('words / min')}`,
  },
  {
    value: 2000,
    label: `200 ${t('words / min')}`,
  },
  {
    value: 1000,
    label: `240 ${t('words / min')}`,
  },
];

export const sizeToSpeedRatioMedium = (
  t: TFunction<'translation', undefined>
) => [
  {
    value: 6000,
    label: `160 ${t('words / min')}`,
  },
  {
    value: 4000,
    label: `200 ${t('words / min')}`,
  },
  {
    value: 2000,
    label: `240 ${t('words / min')}`,
  },
];

const sizeToSpeedRatioSmall = (t: TFunction<'translation', undefined>) => [
  {
    value: 8000,
    label: `160 ${t('words / min')}`,
  },
  {
    value: 6000,
    label: `200 ${t('words / min')}`,
  },
  {
    value: 4000,
    label: `240 ${t('words / min')}`,
  },
];

export const handleScriptSpeedUsingScriptSize = (
  ele: any,
  t: TFunction<'translation', undefined>
) => {
  switch (ele) {
    case 'small':
      return sizeToSpeedRatioSmall(t);

    case 'large':
      return sizeToSpeedRatioMedium(t);

    case 'x-large':
      return sizeToSpeedRatioLarge(t);

    default:
      return sizeToSpeedRatioMedium(t);
  }
};
